export const ERROR = 'ERROR'
export const INFO = 'INFO'
export const SUCCESS = 'SUCCSS'
